class ProductModal extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.openButton = this.querySelector('.gm-popup-trigger');
        this.closeButton = this.querySelector('.gm-popup-card-close');
        this.modal = this.querySelector('.gm-popup-container');
        this.openButton.addEventListener('click', (event) => this.openModal());
        this.closeButton.addEventListener('click', (event) => this.closeModal());
    }
    openModal() {
        this.modal.classList.add('gm-popup__visible');
    }

    closeModal() {
        this.modal.classList.remove('gm-popup__visible');
    }

}

customElements.define("product-modal", ProductModal);